<script>
    export let text = "";
</script>

<div class="divider-with-text">
    <div class="hr-chunk">
        <hr />
    </div>
    {#if text}
        <div class="divider-text body-text">{text}</div>
        <div class="hr-chunk">
            <hr />
        </div>
    {/if}
</div>

<style>
    .divider-with-text {
        display: flex;
        align-items: center;
        text-align: center;
        width: 65%;
    }

    .hr-chunk {
        flex: 1;
        position: relative;
    }

    hr {
        width: 100%;
    }

    .divider-text {
        padding: 0px 8px;
    }
</style>
